module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "historico"
  }, _vm._l((_vm.historico), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n    " + _vm._s(item.usuario + ", " + item.email + ", " + item.acao + ", " + item.nome) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b4204fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notificacao/HistoricoNotificacoes.vue
// module id = 1001
// module chunks = 1